import { getQueryParams } from '../request'

export const getProvinceFromQueryParams = (): string => getQueryParams().province as string
